import React from 'react';
import { theme } from '../../theme';

function Card({ children, style = {}, padding = '1.5rem', title, titleAction }) {
  return (
    <div
      style={{
        background: theme.cardBg,
        borderRadius: '0.75rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04)',
        border: `1px solid ${theme.border}`,
        overflow: 'visible',
        ...style,
      }}
    >
      {title && (
        <div
          style={{
            padding: '1rem 1.5rem',
            borderBottom: `1px solid ${theme.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h3 style={{ fontSize: '1rem', fontWeight: 600, color: theme.text, margin: 0 }}>{title}</h3>
          {titleAction && <div>{titleAction}</div>}
        </div>
      )}
      <div style={{ padding }}>{children}</div>
    </div>
  );
}

export default Card;
